export default __webpack_public_path__ + "static/media/github-api.75826edd.svg";